import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const SkeletonTable = ({ children }) => (
  <table className={styles.table} aria-hidden="true">
    {children}
  </table>
)

SkeletonTable.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default SkeletonTable
